// React Lib
import React, { useState } from "react";
import classnames from 'classnames';
import { CopyToClipboard as Copy } from 'react-copy-to-clipboard';
// Component Styles
import { useStyles } from "./FunctionCardCollectionStyles";
// @otg-one/ui_components/components
import { Typography, Button, Chip, Form, Separator } from "../index";
import { Delete, Edit, ShowMoreVertical } from "../../sap_icons";
import { FunctionGoodsReceipt, CopyToClipboard, AddNote } from "../../icons";
// @otg-one/ui_components/constants
import { Color, FONT_FAMILY, FUNCTION_TYPE, getFunctionTypeBackgroundColor, getFunctionTypeLabelColor } from "../../constants";
import { OverflowMenu } from "../OverflowMenu";
import { IconButton } from "../IconButton";
const NoteRenderer = (props) => {
    const classes = useStyles(props);
    const { data, type, isDragging, isHover, hasUpAndRunning, notes, setNotes, onEditNote, onSaveNote, onDeleteNote, onCopyNote, addNote, functionNote, edit, copyToClipboard, deleteText, addFunctionNote, cancel, saveNote, text } = props;
    const handleChangeNoteTemporarily = e => {
        setNotes(e.target.value);
    };
    const handleOnDeleteNote = () => {
        onEditNote(data, type);
        setNotes('');
    };
    const handleOnSaveNote = () => {
        const noteEl = document.getElementById(`${data.systemID}-note-input`);
        if (noteEl) {
            onSaveNote(data, type, noteEl.value);
            setNotes(noteEl.value);
        }
    };
    return React.createElement(React.Fragment, null,
        (!data.isEditMode && data.notes.length === 0) && (React.createElement(Button, { type: "secondary", color: (isHover || isDragging) ? 'white' : 'blue', alignIcon: "right", icon: React.createElement(AddNote, { style: { width: 24, height: 24, color: Color.primary[500] } }), onClick: onEditNote(data, type) }, addNote)),
        (!data.isEditMode && data.notes.length > 0) && (React.createElement(React.Fragment, null,
            React.createElement(Typography, { fontFamily: FONT_FAMILY.ROBOTO_BOLD, size: 12, color: (isHover || isDragging) ? Color.neutral[0] : Color.neutral[700], style: { marginTop: 18 } }, functionNote),
            React.createElement(Typography, { fontFamily: FONT_FAMILY.ROBOTO_REGULAR_ITALIC, size: 12, color: (isHover || isDragging) ? Color.neutral[0] : Color.neutral[600], style: { marginTop: 3, lineHeight: 1.8 } }, data.notes),
            React.createElement("div", { className: classes.functionBoxCollectionNoteActionsContainer },
                React.createElement("div", { style: { display: 'flex', alignItems: 'center', justifyContent: 'center' } },
                    React.createElement(IconButton, { icon: React.createElement(Edit, null), color: "primary", onClick: onEditNote(data, type), textTooltip: edit, size: "large" }),
                    React.createElement(Copy, { onCopy: onCopyNote, text: data.notes },
                        React.createElement(IconButton, { icon: React.createElement(CopyToClipboard, null), color: "primary", style: { marginLeft: 18 }, textTooltip: copyToClipboard, size: "large" }))),
                React.createElement(IconButton, { icon: React.createElement(Delete, null), color: "danger", onClick: onDeleteNote(data, type), textTooltip: deleteText, size: "large" })))),
        data.isEditMode && (React.createElement(React.Fragment, null,
            React.createElement(Form, { id: `${data.systemID}-note-input`, color: hasUpAndRunning ? 'white' : 'grey', multiline: true, 
                // placeholder="Add Function Note"
                placeholder: addFunctionNote, value: notes, onChange: handleChangeNoteTemporarily, style: { marginTop: 12 } }),
            React.createElement("div", { className: classes.functionCollectionNoteActionsContainer },
                React.createElement(Button, { type: "tertiary", color: (isHover || isDragging) ? 'white' : 'blue', onClick: handleOnDeleteNote }, cancel),
                React.createElement(Button, { type: "tertiary", color: (isHover || isDragging) ? 'white' : 'blue', onClick: handleOnSaveNote }, saveNote)))));
};
NoteRenderer.defaultProps = {
    addNote: 'Add Note',
    functionNote: 'Function Note',
    edit: 'Edit',
    copyToClipboard: 'Copy to Clipboard',
    deleteText: 'Delete Text',
    addFunctionNote: 'Add Function Note',
    cancel: 'Cancel',
    saveNote: 'Save Note'
};
const ProcessRenderer = (props) => {
    const classes = useStyles(props);
    const { func, process, icon, isDragging, isHover, hasUpAndRunning, onEditNote, onSaveNote, onDeleteNote, onCopyNote, handleRemoveProcess, addNote, functionNote, edit, copyToClipboard, deleteText, addFunctionNote, cancel, saveNote, menu, text } = props;
    const [anchorEl, setAnchorEl] = useState(null);
    const [notes, setNotes] = useState(process.notes);
    const handleClickShowMoreIcon = (event) => {
        event.stopPropagation();
        if (!anchorEl) {
            setAnchorEl(event.currentTarget);
        }
    };
    const primaryMenu = [
        {
            text: [menu[0]],
            // text: { functionDetail },
            onClick: () => { }
        },
        {
            text: [menu[1]],
            // text: { removeFromCollection },
            onClick: () => handleRemoveProcess(func, process),
            destructive: true
        }
    ];
    return (React.createElement(React.Fragment, null,
        React.createElement(Separator, { width: 2, type: "n200", marginTop: "10px", marginBottom: "8px" }),
        React.createElement("div", { className: classes.functionCardCollectionTextIconContainer },
            React.createElement("div", { className: classes.functionCardCollectionTextIcon },
                React.createElement(Typography, { fontFamily: FONT_FAMILY.CAPITOLIUM_BOLD, size: 12, color: (isHover || isDragging) ? Color.neutral[0] : Color.neutral[600] }, process.name)),
            React.createElement(ShowMoreVertical, { style: {
                    position: 'absolute',
                    top: 14,
                    right: 0,
                    cursor: 'pointer'
                }, onClick: handleClickShowMoreIcon }),
            React.createElement(OverflowMenu, { anchorElement: anchorEl, setAnchorEl: setAnchorEl, menuItems: primaryMenu })),
        !process.isEditMode && (React.createElement("div", { className: classes.functionCollectionChipContainer },
            process.type.includes(FUNCTION_TYPE.MM) && (React.createElement(Chip, { backgroundColor: getFunctionTypeBackgroundColor(FUNCTION_TYPE.MM), color: getFunctionTypeLabelColor(FUNCTION_TYPE.MM) }, FUNCTION_TYPE.MM)),
            process.type.includes(FUNCTION_TYPE.SD) && (React.createElement(Chip, { backgroundColor: getFunctionTypeBackgroundColor(FUNCTION_TYPE.SD), color: getFunctionTypeLabelColor(FUNCTION_TYPE.SD), style: { marginLeft: process.type[0] !== FUNCTION_TYPE.SD && 8 } }, FUNCTION_TYPE.SD)),
            process.type.includes(FUNCTION_TYPE.PP) && (React.createElement(Chip, { backgroundColor: getFunctionTypeBackgroundColor(FUNCTION_TYPE.PP), color: getFunctionTypeLabelColor(FUNCTION_TYPE.PP), style: { marginLeft: process.type[0] !== FUNCTION_TYPE.PP && 8 } }, FUNCTION_TYPE.PP)),
            process.type.includes(FUNCTION_TYPE.WM) && (React.createElement(Chip, { backgroundColor: getFunctionTypeBackgroundColor(FUNCTION_TYPE.WM), color: getFunctionTypeLabelColor(FUNCTION_TYPE.WM), style: { marginLeft: process.type[0] !== FUNCTION_TYPE.WM && 8 } }, FUNCTION_TYPE.WM)),
            process.type.includes(FUNCTION_TYPE.EWM) && (React.createElement(Chip, { backgroundColor: getFunctionTypeBackgroundColor(FUNCTION_TYPE.EWM), color: getFunctionTypeLabelColor(FUNCTION_TYPE.EWM), style: { marginLeft: process.type[0] !== FUNCTION_TYPE.EWM && 8 } }, FUNCTION_TYPE.EWM)),
            process.type.includes(FUNCTION_TYPE.QM) && (React.createElement(Chip, { backgroundColor: getFunctionTypeBackgroundColor(FUNCTION_TYPE.QM), color: getFunctionTypeLabelColor(FUNCTION_TYPE.QM), style: { marginLeft: process.type[0] !== FUNCTION_TYPE.QM && 8 } }, FUNCTION_TYPE.QM)))),
        React.createElement(NoteRenderer, { data: process, icon: icon, isDragging: isDragging, isHover: isHover, type: "PROCESS", onEditNote: onEditNote, onSaveNote: onSaveNote, onDeleteNote: onDeleteNote, onCopyNote: onCopyNote, hasUpAndRunning: hasUpAndRunning, notes: notes, setNotes: setNotes, addNote: addNote, functionNote: functionNote, edit: edit, copyToClipboard: copyToClipboard, deleteText: deleteText, addFunctionNote: addFunctionNote, cancel: cancel, saveNote: saveNote, text: text })));
};
ProcessRenderer.defaultProps = {
    handleRemoveFunction: () => { },
    menu: ['Function Detail', 'Remove from Collection']
};
const FunctionRenderer = (props) => {
    const classes = useStyles(props);
    const { func, icon, isDragging, isHover, onEditNote, onSaveNote, onDeleteNote, onCopyNote, handleRemoveFunction, handleRemoveProcess, addNote, functionNote, edit, copyToClipboard, deleteText, addFunctionNote, cancel, saveNote, menu, text } = props;
    const [anchorEl, setAnchorEl] = useState(null);
    const [notes, setNotes] = useState(func.notes);
    const handleClickShowMoreIcon = (event) => {
        event.stopPropagation();
        if (!anchorEl) {
            setAnchorEl(event.currentTarget);
        }
    };
    const primaryMenu = [
        {
            text: [menu[0]],
            onClick: () => { }
        },
        {
            text: [menu[1]],
            onClick: () => handleRemoveFunction(func),
            destructive: true
        }
    ];
    return React.createElement(React.Fragment, null,
        React.createElement(Typography, { fontFamily: FONT_FAMILY.ROBOTO_REGULAR, size: 8, color: (isHover || isDragging) ? Color.neutral[0] : Color.neutral[400] }, func.typeOf.toUpperCase().replace(/_/g, " ")),
        React.createElement("div", { className: classes.functionCardCollectionTextIconContainer },
            React.createElement("div", { className: classes.functionCardCollectionTextIcon },
                icon,
                React.createElement(Typography, { fontFamily: FONT_FAMILY.CAPITOLIUM_BOLD, size: 14, color: (isHover || isDragging) ? Color.neutral[0] : Color.neutral[600] }, func.name)),
            React.createElement(ShowMoreVertical, { style: {
                    position: 'absolute',
                    top: 14,
                    right: 0,
                    cursor: 'pointer'
                }, onClick: handleClickShowMoreIcon }),
            React.createElement(OverflowMenu, { anchorElement: anchorEl, setAnchorEl: setAnchorEl, menuItems: primaryMenu })),
        React.createElement(NoteRenderer, { data: func, type: "FUNCTION", icon: icon, isDragging: isDragging, isHover: isHover, onEditNote: onEditNote, onSaveNote: onSaveNote, onDeleteNote: onDeleteNote, onCopyNote: onCopyNote, hasUpAndRunning: func.upAndRunningId !== '', notes: notes, setNotes: setNotes, addNote: addNote, functionNote: functionNote, edit: edit, copyToClipboard: copyToClipboard, deleteText: deleteText, addFunctionNote: addFunctionNote, cancel: cancel, saveNote: saveNote, text: text }),
        func.processes.map(process => (React.createElement(ProcessRenderer, { func: func, process: process, icon: icon, isDragging: isDragging, isHover: isHover, onEditNote: onEditNote, onSaveNote: onSaveNote, onDeleteNote: onDeleteNote, onCopyNote: onCopyNote, hasUpAndRunning: func.upAndRunningId !== '', handleRemoveFunction: handleRemoveFunction, handleRemoveProcess: handleRemoveProcess, addNote: addNote, functionNote: functionNote, edit: edit, copyToClipboard: copyToClipboard, deleteText: deleteText, addFunctionNote: addFunctionNote, cancel: cancel, saveNote: saveNote, menu: menu, text: text }))));
};
FunctionRenderer.defaultProps = {
    menu: ['Function Detail', 'Remove from Collection']
};
export const FunctionCardCollection = (props) => {
    const classes = useStyles(props);
    const { id, func, icon, isDragging, onEditNote, onSaveNote, onDeleteNote, onCopyNote, handleRemoveFunction, handleRemoveProcess, addNote, functionNote, edit, copyToClipboard, deleteText, addFunctionNote, cancel, saveNote, menu, text } = props;
    const [isHover, setIsHover] = useState(false);
    const handleOnMouseOver = () => setIsHover(true);
    const handleOnMouseOut = () => setIsHover(false);
    const functionBoxCollectionIconClasses = classnames({
        [classes.functionCardCollectionContainer]: true,
        [classes.functionCardCollectionContainerDragged]: isDragging,
    });
    return (React.createElement("div", { id: id, className: functionBoxCollectionIconClasses, onMouseEnter: handleOnMouseOver, onMouseLeave: handleOnMouseOut },
        React.createElement(FunctionRenderer, { func: func, icon: icon, isDragging: isDragging, isHover: isHover, onEditNote: onEditNote, onSaveNote: onSaveNote, onDeleteNote: onDeleteNote, onCopyNote: onCopyNote, handleRemoveFunction: handleRemoveFunction, handleRemoveProcess: handleRemoveProcess, addNote: addNote, functionNote: functionNote, edit: edit, copyToClipboard: copyToClipboard, deleteText: deleteText, addFunctionNote: addFunctionNote, cancel: cancel, saveNote: saveNote, menu: menu, text: text })));
};
FunctionCardCollection.defaultProps = {
    func: {
        systemID: `12345`,
        name: `Einlagerung`,
        typeOf: `WAREHOUSE_LOGISTICS`,
        processes: [
            {
                systemID: "TEST_1",
                name: "Einlagerung zum Transportbedarf",
                type: [FUNCTION_TYPE.MM, FUNCTION_TYPE.WM],
                notes: ""
            },
            {
                systemID: "TEST_2",
                name: "Lagereinheit einlagern",
                type: [FUNCTION_TYPE.EWM],
                notes: ""
            }
        ],
        notes: "THIS IS A VERY LONG NOTE",
        edit: 'Edit',
        isEditMode: false
    },
    text: {
        addNote: 'Add Note!',
        functionNote: 'Function Note',
        edit: 'Edit',
        copyToClipboard: 'Copy to Clipboard',
        deleteText: 'Delete Text',
        addFunctionNote: 'Add Function Note',
        cancel: 'Cancel',
        saveNote: 'Save Note'
    },
    icon: React.createElement(FunctionGoodsReceipt, null),
    isDragging: false,
    onEditNote: () => { },
    onSaveNote: () => { },
    onDeleteNote: () => { },
    onCopyNote: () => { }
};
export default React.memo(FunctionCardCollection);
